import React from 'react';
import Chip from '@Shared.Angular/flowingly.components/Chip/Chip';

type TagListProps = {
  tagsByGroupName: Record<string, { tagNames: string[]; color: string }>;
  showBorder?: boolean;
};

const TagList = ({ tagsByGroupName, showBorder = true }: TagListProps) => {
  const hasTags = Object.keys(tagsByGroupName).length > 0;

  return (
    <div
      className={`tag-list-container ${showBorder ? 'with-border' : ''}`}
      data-testid="tag-list-container"
    >
      {hasTags ? (
        Object.entries(tagsByGroupName).map(([groupName, groupInfo]) => (
          <div
            key={groupName}
            className="tag-group"
            data-testid={`tag-list-group-${groupName}`}
          >
            <p
              className="category-label"
              data-testid={`tag-list-group-label-${groupName}`}
            >
              {groupName}
            </p>
            <div className="chip-wrapper">
              {groupInfo.tagNames.map((tagName) => (
                <div key={tagName} data-testid={`tag-list-tag-${tagName}`}>
                  <Chip name={tagName} color={groupInfo.color} />
                </div>
              ))}
            </div>
          </div>
        ))
      ) : (
        <span className="no-tags-text" data-testid="tag-list-empty-state">
          No Tags Added
        </span>
      )}
    </div>
  );
};

export default TagList;
